import React from "react";
import { ReasonContainer, SelectBox } from "../../styled";

const cancelReasons = [
  "단순 변심이에요",
  "상품을 다시 선택하고 싶어요",
  "배송이 너무 늦을 것 같아요",
  "결제 수단을 변경하고 싶어요",
  "옵션이나 주소를 잘못 입력했어요",
  "상품 정보가 다르게 느껴졌어요",
  "재고가 없다고 연락 받았어요",
  "할인을 다시 적용하고 싶어요",
  "고객센터 안내로 취소해요",
  "기타 (직접 입력)",
];

const Reason = ({ selectedReason, onSelectChange, customReason, onCustomChange }) => {
  return (
    <ReasonContainer>
      <span>취소 사유를 선택해주세요</span>
      <SelectBox value={selectedReason} onChange={onSelectChange}>
        <option value="">사유선택</option>
        {cancelReasons.map((reason) => (
          <option key={reason} value={reason}>
            {reason}
          </option>
        ))}
      </SelectBox>
      {selectedReason === "기타 (직접 입력)" && (
        <textarea
          placeholder="사유를 입력해주세요"
          value={customReason}
          onChange={onCustomChange}
        />
      )}
    </ReasonContainer>
  );
};

export default Reason;
